import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface TypeConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'app-type-confirm-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
  ],
  templateUrl: './type-confirm-dialog.html',
  styleUrl: './type-confirm-dialog.scss',
})
export class TypeConfirmDialog {
  challengeCode = '';
  typedValue = '';
  private readonly challengeChars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';

  constructor(
    public dialogRef: MatDialogRef<TypeConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: TypeConfirmDialogData
  ) {
    this.challengeCode = this.generateChallengeCode();
  }

  get confirmText(): string {
    return (this.data.confirmText ?? 'Delete').trim() || 'Delete';
  }

  get cancelText(): string {
    return (this.data.cancelText ?? 'Cancel').trim() || 'Cancel';
  }

  get isMatch(): boolean {
    return this.typedValue === this.challengeCode;
  }

  confirm(): void {
    if (!this.isMatch) {
      return;
    }
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  blockCopyPaste(event: Event): void {
    event.preventDefault();
  }

  blockPasteShortcut(event: KeyboardEvent): void {
    const key = event.key.toLowerCase();
    if ((event.ctrlKey || event.metaKey) && (key === 'v' || key === 'c' || key === 'x' || key === 'a')) {
      event.preventDefault();
    }
  }

  private generateChallengeCode(): string {
    let code = '';
    for (let i = 0; i < 8; i++) {
      const index = Math.floor(Math.random() * this.challengeChars.length);
      code += this.challengeChars.charAt(index);
    }
    return code;
  }
}
